import {
  ComponentFactoryResolver,
  Injectable,
  ViewContainerRef,
} from '@angular/core';
import { AppType } from 'src/environments/environmentTypes';
import { AihobsEcsRegisterSendComponent } from './aihobs-ecs/aihobs-ecs-register-send/aihobs-ecs-register-send.component';
import { AihobsEcsResetPasswordComponent } from './aihobs-ecs/aihobs-ecs-reset-password/aihobs-ecs-reset-password.component';
import { AihobsEcsUnblockComponent } from './aihobs-ecs/aihobs-ecs-unblock/aihobs-ecs-unblock.component';
import { AihobsEcsComponent } from './aihobs-ecs/aihobs-ecs/aihobs-ecs.component';
import { HicreaSsoRegisterSendComponent as AissSsoRegisterSendComponent } from './aiss-sso/aiss-sso-register-send/aiss-sso-register-send.component';
import { HicreaSsoResetPasswordComponent as AissSsoResetPasswordComponent } from './aiss-sso/aiss-sso-reset-password/aiss-sso-reset-password.component';
import { HicreaSsoUnblockComponent as AissSsoUnblockComponent } from './aiss-sso/aiss-sso-unblock/aiss-sso-unblock.component';
import { HicreaSsoComponent as AissSsoComponent } from './aiss-sso/aiss-sso/aiss-sso.component';
import { CollaboPortalUpdatedPasswordComponent } from './collabo-portal/collabo-portal-updated-password/collabo-portal-updated-password.component';
import { ConnectDoctorsIdRegisterSendComponent } from './collabo-portal/connect-doctors-id/connect-doctors-id-register-send/connect-doctors-id-register-send.component';
import { ConnectDoctorsIdComponent } from './collabo-portal/connect-doctors-id/connect-doctors-id.component';
import { HayfeverRegisterSendComponent } from './hayfever/hayfever-register-send/hayfever-register-send.component';
import { HayfeverResetPasswordComponent } from './hayfever/hayfever-reset-password/hayfever-reset-password.component';
import { HayfeverUnblockComponent } from './hayfever/hayfever-unblock/hayfever-unblock.component';
import { HayfeverComponent } from './hayfever/hayfever/hayfever.component';
import { HealthpicksOperatorRegisterSendComponent } from './healthpicks-operator/healthpicks-operator-register-send/healthpicks-operator-register-send.component';
import { HealthpicksOperatorResetPasswordComponent } from './healthpicks-operator/healthpicks-operator-reset-password/healthpicks-operator-reset-password.component';
import { HealthpicksOperatorUnblockComponent } from './healthpicks-operator/healthpicks-operator-unblock/healthpicks-operator-unblock.component';
import { HealthpicksOperatorComponent } from './healthpicks-operator/healthpicks-operator/healthpicks-operator.component';
import { HealthpicksRegisterSendComponent } from './healthpicks/healthpicks-register-send/healthpicks-register-send.component';
import { HealthpicksResetPasswordComponent } from './healthpicks/healthpicks-reset-password/healthpicks-reset-password.component';
import { HealthpicksUnblockComponent } from './healthpicks/healthpicks-unblock/healthpicks-unblock.component';
import { HealthpicksComponent } from './healthpicks/healthpicks/healthpicks.component';
import { HicreaSsoRegisterSendComponent } from './hicrea-sso/hicrea-sso-register-send/hicrea-sso-register-send.component';
import { HicreaSsoResetPasswordComponent } from './hicrea-sso/hicrea-sso-reset-password/hicrea-sso-reset-password.component';
import { HicreaSsoUnblockComponent } from './hicrea-sso/hicrea-sso-unblock/hicrea-sso-unblock.component';
import { HicreaSsoComponent } from './hicrea-sso/hicrea-sso/hicrea-sso.component';
import { LasuiteRegisterSendComponent } from './lasuite/lasuite-register-send/lasuite-register-send.component';
import { LasuiteResetPasswordComponent } from './lasuite/lasuite-reset-password/lasuite-reset-password.component';
import { LasuiteUnblockComponent } from './lasuite/lasuite-unblock/lasuite-unblock.component';
import { LasuiteComponent } from './lasuite/lasuite/lasuite.component';
import { SasClinicRegisterSendComponent } from './sas-clinic/sas-clinic-register-send/sas-clinic-register-send.component';
import { SasClinicResetPasswordComponent } from './sas-clinic/sas-clinic-reset-password/sas-clinic-reset-password.component';
import { SasClinicUnblockComponent } from './sas-clinic/sas-clinic-unblock/sas-clinic-unblock.component';
import { SasClinicComponent } from './sas-clinic/sas-clinic/sas-clinic.component';
import { SasManagementRegisterSendComponent } from './sas-management/sas-management-register-send/sas-management-register-send.component';
import { SasManagementResetPasswordComponent } from './sas-management/sas-management-reset-password/sas-management-reset-password.component';
import { SasManagementUnblockComponent } from './sas-management/sas-management-unblock/sas-management-unblock.component';
import { SasManagementComponent } from './sas-management/sas-management/sas-management.component';
import { SgzpApp4RegisterSendComponent } from './sgzp-app4/sgzp-app4-register-send/sgzp-app4-register-send.component';
import { SgzpApp4ResetPasswordComponent } from './sgzp-app4/sgzp-app4-reset-password/sgzp-app4-reset-password.component';
import { SgzpApp4UnblockComponent } from './sgzp-app4/sgzp-app4-unblock/sgzp-app4-unblock.component';
import { SgzpApp4Component } from './sgzp-app4/sgzp-app4/sgzp-app4.component';
import { SgzpApp5RegisterSendComponent } from './sgzp-app5/sgzp-app5-register-send/sgzp-app5-register-send.component';
import { SgzpApp5ResetPasswordComponent } from './sgzp-app5/sgzp-app5-reset-password/sgzp-app5-reset-password.component';
import { SgzpApp5UnblockComponent } from './sgzp-app5/sgzp-app5-unblock/sgzp-app5-unblock.component';
import { SgzpApp5Component } from './sgzp-app5/sgzp-app5/sgzp-app5.component';
import { SgzpApp6RegisterSendComponent } from './sgzp-app6/sgzp-app6-register-send/sgzp-app6-register-send.component';
import { SgzpApp6ResetPasswordComponent } from './sgzp-app6/sgzp-app6-reset-password/sgzp-app6-reset-password.component';
import { SgzpApp6UnblockComponent } from './sgzp-app6/sgzp-app6-unblock/sgzp-app6-unblock.component';
import { SgzpApp6Component } from './sgzp-app6/sgzp-app6/sgzp-app6.component';
import { SgzpMasterRegisterSendComponent } from './sgzp-master/sgzp-master-register-send/sgzp-master-register-send.component';
import { SgzpMasterResetPasswordComponent } from './sgzp-master/sgzp-master-reset-password/sgzp-master-reset-password.component';
import { SgzpMasterUnblockComponent } from './sgzp-master/sgzp-master-unblock/sgzp-master-unblock.component';
import { SgzpMasterComponent } from './sgzp-master/sgzp-master/sgzp-master.component';
import { SokusaiManagementRegisterSendComponent } from './sokusai-management/sokusai-management-register-send/sokusai-management-register-send.component';
import { SokusaiManagementResetPasswordComponent } from './sokusai-management/sokusai-management-reset-password/sokusai-management-reset-password.component';
import { SokusaiManagementUnblockComponent } from './sokusai-management/sokusai-management-unblock/sokusai-management-unblock.component';
import { SokusaiManagementComponent } from './sokusai-management/sokusai-management/sokusai-management.component';
import { SokusaiRegisterSendComponent } from './sokusai/sokusai-register-send/sokusai-register-send.component';
import { SokusaiResetPasswordComponent } from './sokusai/sokusai-reset-password/sokusai-reset-password.component';
import { SokusaiUnblockComponent } from './sokusai/sokusai-unblock/sokusai-unblock.component';
import { SokusaiComponent } from './sokusai/sokusai/sokusai.component';
import { TradersRegisterSendComponent } from './traders/traders-register-send/traders-register-send.component';
import { TradersResetPasswordComponent } from './traders/traders-reset-password/traders-reset-password.component';
import { TradersUnblockComponent } from './traders/traders-unblock/traders-unblock.component';
import { TradersComponent } from './traders/traders/traders.component';
import { WellbeanRegisterSendComponent } from './wellbean/wellbean-register-send/wellbean-register-send.component';
import { WellbeanResetPasswordComponent } from './wellbean/wellbean-reset-password/wellbean-reset-password.component';
import { WellbeanUnblockComponent } from './wellbean/wellbean-unblock/wellbean-unblock.component';
import { WellbeanComponent } from './wellbean/wellbean/wellbean.component';
import { WelltectRegisterSendComponent } from './welltect/welltect-register-send/welltect-register-send.component';
import { WelltectResetPasswordComponent } from './welltect/welltect-reset-password/welltect-reset-password.component';
import { WelltectUnblockComponent } from './welltect/welltect-unblock/welltect-unblock.component';
import { WelltectComponent } from './welltect/welltect/welltect.component';
import { DoctorsStationComponent } from './doctors-station/doctors-station/doctors-station.component';
import { DoctorsStationRegisterSendComponent } from './doctors-station/doctors-station-register-send/doctors-station-register-send.component';
import { DoctorsStationResetPasswordComponent } from './doctors-station/doctors-station-reset-password/doctors-station-reset-password.component';
import { DoctorsStationUnblockComponent } from './doctors-station/doctors-station-unblock/doctors-station-unblock.component';

@Injectable({
  providedIn: 'root',
})
export class SwitchAppService {
  constructor() {}

  private configs: Partial<
    Record<
      AppType,
      {
        authorize?: any;
        emailSend?: any;
        unblock?: any;
        resetPassword?: any;
        updatedPassword?: any;
      }
    >
  > = {
    // 'cportal-sgzp-app2': {
    //   authorize: SgzpApp2Component,
    //   emailSend: SgzpApp2RegisterSendComponent,
    //   resetPassword: SgzpApp2ResetPasswordComponent,
    //   unblock: SgzpApp2UnblockComponent,
    // },
    'cportal-sgzp-app4': {
      authorize: SgzpApp4Component,
      emailSend: SgzpApp4RegisterSendComponent,
      resetPassword: SgzpApp4ResetPasswordComponent,
      unblock: SgzpApp4UnblockComponent,
    },
    'cportal-sgzp-app5': {
      authorize: SgzpApp5Component,
      emailSend: SgzpApp5RegisterSendComponent,
      resetPassword: SgzpApp5ResetPasswordComponent,
      unblock: SgzpApp5UnblockComponent,
    },
    'cportal-sgzp-app6': {
      authorize: SgzpApp6Component,
      emailSend: SgzpApp6RegisterSendComponent,
      resetPassword: SgzpApp6ResetPasswordComponent,
      unblock: SgzpApp6UnblockComponent,
    },
    'cportal-hicrea-sso': {
      authorize: HicreaSsoComponent,
      emailSend: HicreaSsoRegisterSendComponent,
      resetPassword: HicreaSsoResetPasswordComponent,
      unblock: HicreaSsoUnblockComponent,
    },
    'cportal-aiss-sso': {
      authorize: AissSsoComponent,
      emailSend: AissSsoRegisterSendComponent,
      resetPassword: AissSsoResetPasswordComponent,
      unblock: AissSsoUnblockComponent,
    },
    'cportal-aihobs-ecs': {
      authorize: AihobsEcsComponent,
      emailSend: AihobsEcsRegisterSendComponent,
      resetPassword: AihobsEcsResetPasswordComponent,
      unblock: AihobsEcsUnblockComponent,
    },
    'cportal-sgzp-master': {
      authorize: SgzpMasterComponent,
      emailSend: SgzpMasterRegisterSendComponent,
      resetPassword: SgzpMasterResetPasswordComponent,
      unblock: SgzpMasterUnblockComponent,
    },
    welltect: {
      authorize: WelltectComponent,
      emailSend: WelltectRegisterSendComponent,
      resetPassword: WelltectResetPasswordComponent,
      unblock: WelltectUnblockComponent,
    },
    hayfever: {
      authorize: HayfeverComponent,
      emailSend: HayfeverRegisterSendComponent,
      resetPassword: HayfeverResetPasswordComponent,
      unblock: HayfeverUnblockComponent,
    },
    'sas-clinic': {
      authorize: SasClinicComponent,
      emailSend: SasClinicRegisterSendComponent,
      resetPassword: SasClinicResetPasswordComponent,
      unblock: SasClinicUnblockComponent,
    },
    traders: {
      authorize: TradersComponent,
      emailSend: TradersRegisterSendComponent,
      resetPassword: TradersResetPasswordComponent,
      unblock: TradersUnblockComponent,
    },
    'cportal-connect': {
      authorize: ConnectDoctorsIdComponent,
      emailSend: ConnectDoctorsIdRegisterSendComponent,
      resetPassword: ConnectDoctorsIdComponent,
      unblock: ConnectDoctorsIdComponent,
    },
    wellbean: {
      authorize: WellbeanComponent,
      emailSend: WellbeanRegisterSendComponent,
      resetPassword: WellbeanResetPasswordComponent,
      unblock: WellbeanUnblockComponent,
    },
    lasuite: {
      authorize: LasuiteComponent,
      emailSend: LasuiteRegisterSendComponent,
      resetPassword: LasuiteResetPasswordComponent,
      unblock: LasuiteUnblockComponent,
    },
    sokusai: {
      authorize: SokusaiComponent,
      emailSend: SokusaiRegisterSendComponent,
      resetPassword: SokusaiResetPasswordComponent,
      unblock: SokusaiUnblockComponent,
    },
    'sokusai-management': {
      authorize: SokusaiManagementComponent,
      emailSend: SokusaiManagementRegisterSendComponent,
      resetPassword: SokusaiManagementResetPasswordComponent,
      unblock: SokusaiManagementUnblockComponent,
    },
    'sas-management': {
      authorize: SasManagementComponent,
      emailSend: SasManagementRegisterSendComponent,
      resetPassword: SasManagementResetPasswordComponent,
      unblock: SasManagementUnblockComponent,
    },
    cportal: {
      // 以下のコンポーネントは利用している. https://doctors-jp.backlog.com/view/CBPT-4671
      updatedPassword: CollaboPortalUpdatedPasswordComponent,
    },
    healthpicks: {
      authorize: HealthpicksComponent,
      emailSend: HealthpicksRegisterSendComponent,
      resetPassword: HealthpicksResetPasswordComponent,
      unblock: HealthpicksUnblockComponent,
    },
    'healthpicks-operator': {
      authorize: HealthpicksOperatorComponent,
      emailSend: HealthpicksOperatorRegisterSendComponent,
      resetPassword: HealthpicksOperatorResetPasswordComponent,
      unblock: HealthpicksOperatorUnblockComponent,
    },
  };

  getComponents(appType: AppType) {
    return this.configs[appType];
  }

  setComponent(
    clientId: string,
    appType: AppType,
    viewContainerRef: ViewContainerRef,
    resolve: ComponentFactoryResolver,
    pageType:
      | 'authorize'
      | 'emailSend'
      | 'unblock'
      | 'resetPassword'
      | 'updatedPassword',
    options?: {
      ticket: string;
      email: string;
      _csrf: string;
    }
  ) {
    const appConfig = this.getComponents(appType);
    if (!appConfig?.[pageType]) return;
    const factory = resolve.resolveComponentFactory(appConfig[pageType]);
    const component = viewContainerRef.createComponent(factory);
    (component as any).instance.clientId = clientId;
    (component as any).instance.ticket = options?.ticket;
    (component as any).instance.email = options?.email;
    (component as any).instance._csrf = options?._csrf;
    const instance = component.instance;

    // 強制的に呼び出す
    if ((instance as any).ngOnChanges) (instance as any).ngOnChanges();
    if ((instance as any).ngOnInit) (instance as any).ngOnInit();
  }
}
